export enum Endpoint {
  PLAYER = 'Player',
  HEALTH = 'health',
  GET_RULE_COMPONENTS = 'api/static/components',
  GET_RULE_COMPONENT_ATTRIBUTES = 'api/static/component-attributes',
  GET_RULE_COMPARATORS = 'api/static/comparators',
  GET_RISK_PROFILES = 'api/static/risk-profiles',

  GET_FIREBASE_ADMIN_TOKEN = 'api/auth/get-admin-custom-firebase-token',

  PLAYERS = 'api/users/users',
  PLAYER_DETAILS = 'api/users/user',
  PLAYER_TRADES = 'api/users/trades',
  PLAYERS_LIST = 'api/users/users',
  PINNED_PLAYERS_LIST = 'api/users/pinned-users',
  FLAG_PLAYER = 'api/users/update-risk-flag',
  PIN_PLAYER = 'api/users/update-pinned',

  CREATE_RULE = 'api/alert-rules/create-alert-rule',
  UPDATE_RULE = 'api/alert-rules/update-alert-rule',
  GET_RULE = 'api/alert-rules/alert-rule',
  GET_RULES = 'api/alert-rules/alert-rules',
  
  GET_ALERTS = 'api/alerts/alerts',
  GET_ALERT = 'api/alerts/alert',
  ACKNOWLEDGE_ALERT = 'api/alerts/acknowledge',
  ADD_ALERT_NOTES = 'api/alerts/add-notes',

  GET_REPORT_DATA = 'api/report/data',
}

export enum TagId {
  PARTIAL_LIST = 'PARTIAL-LIST',
  PLAYER = 'PLAYER',
  PLAYERS = 'PLAYERS',
  PINNED_PLAYERS = 'PINNED-PLAYERS',
  PLAYER_TRADES = 'PLAYER-TRADES',
  HEALTH = 'HEALTH',
  RULES = 'RULES',
  ALERTS = 'ALERTS',
  RULES_COMPONENTS = 'RULES-COMPONENTS',
  RULES_COMPONENT_ATTRIBUTES = 'RULES-COMPONENT-ATTRIBUTES',
  RULES_COMPARATORS = 'RULES-COMPARATORS',
  RISK_PROFILES = 'RISK-PROFILES',
}

export const TAG_TYPES: readonly string[] = Object.values(Endpoint);
export const TAG_IDS: readonly string[] = Object.values(TagId);
